import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { Children } from 'react';
export const DivisibleStack = (props) => {
    const { children, divider, wrapper } = props;
    let content;
    if (divider) {
        content = Children.toArray(children)
            .filter(Boolean)
            .flatMap((child, index) => {
            if (index === 0) {
                return [child];
            }
            return [divider && _jsx("div", { className: divider }, `divider-${index}`), child];
        });
    }
    else {
        content = children;
    }
    if (wrapper) {
        return _jsx("div", { className: wrapper, children: content });
    }
    else {
        return _jsx(_Fragment, { children: content });
    }
};
